import { Pipe, PipeTransform } from '@angular/core';
import { Signaltag } from '../../models/trend-live-models/OPTag';

@Pipe({
  name: 'legendTags'
})
export class LegendTagsPipe implements PipeTransform {

  transform(tags: Signaltag[]) {
    return tags.filter(entry => entry.trendExplorer.added);
  }

}



// WEBPACK FOOTER //
// ./src/components/trend-explorer/legend-tags.pipe.ts